/* eslint-disable @typescript-eslint/no-floating-promises */

'use client'

import React, { useEffect, useState } from 'react'
import { challanAppRedirectDesktop } from 'homepageMock'
import MobileChallanModal from '@components/MainWidget/ChallanWidgetModals/MobileChallanModal'
import DoMoreThanChallanModal from '@components/MainWidget/ChallanWidgetModals/DoMoreThanChallanModal'
import { ProductModal } from '@components/Home/ProductCardButton/ProductModal/ProductModal'
import { DO_MORE_BUTTON_TEXT, getWidgetId } from '@components/MainWidget/ChallanWidgetModals/constants'
import { fetchDeepLink } from '@services/fetchDeepLink'
import { Overflow } from '@enums/OverflowTypes'

interface VasAppRedirectWrapperProps {
  isMobile: boolean
  vasWrapperProps?: object
  vasFallbackScreenData?: Record<string, any>
  regNum: string
  mobileNo: string
  vehicleInfoData: Record<string, any>
  segmentEventCommonProperties: Record<string, string> | null
  setShowMobileChallanModal: Function
  isBottomFloater: boolean
  onHide: Function
  showMwebChallanModal: boolean
  setShowMwebChallanModal: Function
  setShowDoMoreThanChallanModal: Function
  showDoMoreThanChallanModal: boolean
  widgetType: string
}

const VasAppRedirectWrapper: React.FC<VasAppRedirectWrapperProps> = ({
  mobileNo,
  isMobile,
  vasWrapperProps,
  vasFallbackScreenData,
  regNum,
  vehicleInfoData,
  segmentEventCommonProperties,
  setShowMobileChallanModal,
  isBottomFloater,
  onHide,
  showMwebChallanModal,
  setShowMwebChallanModal,
  setShowDoMoreThanChallanModal,
  showDoMoreThanChallanModal,
  widgetType,
}) => {
  const [downloadUrl, setDownloadUrl] = useState('')
  useEffect(() => {
    if (showMwebChallanModal || isMobile) {
      document.documentElement.style.overflowY = Overflow.Hidden
    }
  }, [showMwebChallanModal, isMobile])

  useEffect(() => {
    if (!isMobile) {
      const fetchData = async (regNo, challanWidgetType, mobileNo, selectedProvider) => {
        const deepLink = await fetchDeepLink({ regNo, widgetType: challanWidgetType, mobileNo, selectedProvider })
        setDownloadUrl(deepLink)
      }

      fetchData(regNum, widgetType, mobileNo, vehicleInfoData?.selectedProvider)
    } else setShowMwebChallanModal(true)
  }, [])

  useEffect(() => {
    const setWidgetDisplay = (display: string) => {
      const widgetElements = document.querySelectorAll(getWidgetId(widgetType))
      widgetElements.forEach(widgetElement => {
        const element = widgetElement as HTMLElement
        element.style.display = display
      })
    }

    if (isBottomFloater) {
      setWidgetDisplay('none')
    } else {
      setWidgetDisplay('')
    }

    return () => {
      setWidgetDisplay('')
    }
  }, [isBottomFloater])

  const handleMobileChallanModalClose = () => {
    document.documentElement.style.overflowY = Overflow.Scroll
    setShowMwebChallanModal(false)
    setShowDoMoreThanChallanModal(true)
  }

  const handleDoMoreThanChallanModalClose = () => {
    if (onHide) {
      onHide()
    }

    document.documentElement.style.overflowY = Overflow.Scroll
    setShowDoMoreThanChallanModal(false)
    setShowMobileChallanModal(false)
  }

  return (
    <>
      {showMwebChallanModal && isMobile && (
        <MobileChallanModal
          vasWrapperProps={vasWrapperProps}
          onClose={handleMobileChallanModalClose}
          vehicleInfoData={vehicleInfoData}
          segmentEventCommonProperties={segmentEventCommonProperties}
          newVasLandingFlow
          widgetType={widgetType}
        />
      )}

      {showDoMoreThanChallanModal && isMobile && (
        <DoMoreThanChallanModal
          onClose={handleDoMoreThanChallanModalClose}
          heading={vasFallbackScreenData?.fallbackHeading}
          subheading={vasFallbackScreenData?.fallbackSubHeading}
          cards={vasFallbackScreenData?.fallBackCards}
          buttonText={DO_MORE_BUTTON_TEXT}
          vehicleInfoData={vehicleInfoData}
          widgetType={widgetType}
        />
      )}

      {!isMobile && (
        <ProductModal
          vasWrapperProps={vasWrapperProps}
          modalData={challanAppRedirectDesktop?.modalData}
          show
          setShow={() => {
            setShowMobileChallanModal(false)
            document.documentElement.style.overflowY = Overflow.Scroll
          }}
          downloadUrl={downloadUrl}
          vehicleInfoData={vehicleInfoData}
          segmentEventCommonProperties={segmentEventCommonProperties}
          regNum={regNum}
          mobileNo={mobileNo}
          isBottomFloater={isBottomFloater}
          newVasLandingFlow
          widgetType={widgetType}
        />
      )}
    </>
  )
}

export default VasAppRedirectWrapper
